import _ from "lodash";
import DailyMenuOption from "@/model/DailyMenuOption";

export default class MenuGroupItem {
  private constructor (
    readonly id:string,
    readonly title: string,
    readonly kind: string,
    readonly subGroupList: MenuGroupItem[],
    readonly optionList: DailyMenuOption[],
    readonly tags: string[]
  ) {}

  get menuOptionOffered (): any | undefined {
    return _.find(this.optionList,(option:DailyMenuOption) => {
      return option.offer
    } )

  }

  get selectedOption (): DailyMenuOption | undefined {
    return _.find(this.optionList,(option:DailyMenuOption) => {
      return option.isSelected
    } )

  }

  static createFromList (responseData: any[]): MenuGroupItem[] {
    return responseData.map( (value:any):MenuGroupItem => MenuGroupItem.createDailyMenuInterface(value))
  }

  static createDailyMenuInterface (responseData: any): MenuGroupItem {
    return new MenuGroupItem(
      responseData.id,
      responseData.title,
      responseData.kind,
      responseData.subGroups ? MenuGroupItem.createFromList(responseData.subGroups):[],
      responseData.slots ? DailyMenuOption.createFromResponse(responseData.slots):[],
      responseData.tags
    )
  }
}
